import { useIntl } from "react-intl";

import type { NoteBrowsingHistoryNode } from "~/client/components/search/hooks/useNoteBrowsingHistory";
import type { SearchHistoryEntry } from "~/client/components/search/hooks/useSearchHistory";
import { EntryList as NoteBrowsingHistory } from "~/client/components/search/NoteBrowsingHistory/EntryList";
import { SearchBoxDropdownSection } from "~/client/components/search/SearchBoxDropdown/SearchBoxDropdownSection";
import { WithEmptyList } from "~/client/components/search/SearchBoxDropdown/WithEmptyList";
import { WithLoading } from "~/client/components/search/SearchBoxDropdown/WithLoading";
import { EntryListContainer as SearchHistory } from "~/client/components/search/SearchHistory/EntryListContainer";
import { useSelectListItemByKey } from "~/client/hooks/useSelectListItemByKey";
import type { Connection } from "~/client/utils/relay";

interface Props {
  onSearch(): void;
  searchHistory: {
    entries: ReadonlyArray<SearchHistoryEntry>;
    isLoading: boolean;
  };
  noteBrowsingHistory: {
    entries: Connection<NoteBrowsingHistoryNode>;
    isLoading: boolean;
  };
}
export const HistoryList: React.FC<Props> = ({ onSearch, searchHistory, noteBrowsingHistory }) => {
  const intl = useIntl();

  const [isItemSelected, isSubmitting, isSelected] = useSelectListItemByKey([
    searchHistory.entries.length,
    noteBrowsingHistory.entries.edges.length,
  ]);

  if (isSubmitting && !isSelected) {
    onSearch();
  }

  return (
    <>
      <SearchBoxDropdownSection title={intl.formatMessage({ id: "searchBox.searchHistory" })}>
        <WithLoading isLoading={searchHistory.isLoading}>
          <SearchHistory
            listIndex={0}
            entries={searchHistory.entries}
            listItemSelection={{
              isItemSelected,
              isSubmitting,
            }}
          />
        </WithLoading>
      </SearchBoxDropdownSection>
      <SearchBoxDropdownSection title={intl.formatMessage({ id: "searchBox.noteBrowsingHistory" })} noSeparator>
        <WithLoading isLoading={noteBrowsingHistory.isLoading}>
          <WithEmptyList
            itemCount={noteBrowsingHistory.entries.edges.length}
            message={intl.formatMessage({ id: "searchBox.recentlyViewedNoteDoesNotExist" })}
          >
            <NoteBrowsingHistory
              listIndex={1}
              entries={noteBrowsingHistory.entries}
              listItemSelection={{
                isItemSelected,
                isSubmitting,
              }}
            />
          </WithEmptyList>
        </WithLoading>
      </SearchBoxDropdownSection>
    </>
  );
};
